export default __webpack_public_path__ + "answers_now_logo_purple.png";